import { BooleanField, Datagrid, List, FunctionField, TextField } from 'react-admin';

export const MonitoringList = () => (
	<List>
		<Datagrid rowClick="edit">
			<TextField source="id" />
			<TextField source="description" />
			<TextField source="database" />
			<TextField source="threshold" />
			<TextField source="executionTime" />
			<FunctionField
				label="Priorität"
				render={(record: any) => {
					const map: Record<number, string> = {
						1: 'info',
						2: 'debug',
						3: 'warning',
						4: 'fatal error',
					};
					return map[record?.priority] ?? 'undefined';
				}}
			/>
			<BooleanField source="status" />
		</Datagrid>
	</List>
);